import api from "../../api";
import {SystemAgentDomain} from "../../Types";
import {param, typedQuery} from "../typing";

export const systemAgents = typedQuery(
  ["systemAgents", param<SystemAgentDomain>("systemAgentDomain")],
  async domain => await api.systemAgents.list(domain),
);
